// assets/button-top.js
if (!customElements.get("button-top")) {
  customElements.define(
    "button-top",
    class ButtonScrollTop extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector(".button-top");
        this.fixedContent = this.parentElement;
        this.lastKnownScrollY = 0;
        this.ticking = false;

        if (!this.button || !this.fixedContent) {
          return;
        }

        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);

        window.addEventListener("scroll", this.handleScroll, { passive: true });
        window.addEventListener("load", this.handleScroll);
        window.addEventListener("resize", this.handleScroll);

        this.button.addEventListener("click", (event) => {
          event.preventDefault();
          this.handleClick();
        });

        this.updateVisibility();
      }

      handleScroll() {
        this.lastKnownScrollY =
          window.scrollY ||
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;

        if (this.ticking) {
          return;
        }

        this.ticking = true;

        window.requestAnimationFrame(() => {
          this.updateVisibility();
          this.ticking = false;
        });
      }

      updateVisibility() {
        if (this.lastKnownScrollY > 400) {
          this.fixedContent.classList.add("button-top-visible");
          this.button.classList.add("button-top-visible");
        } else {
          this.fixedContent.classList.remove("button-top-visible");
          this.button.classList.remove("button-top-visible");
        }
      }

      handleClick() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  );
}
